<style>
.bg-primary {
  background-color: #1a3665 !important;
}
.bg-active {
  background-color: #3e5d92;
}
.bg-subactive {
  background-color: #486ba7;
}
</style>
<template>
  
    <!-- Data Peserta -->
    <CCardBody>
      <CRow>
        <div class="col-sm-12 col-xl-4">
          <div class="form-group">
            <CSelect
              class="float-left"
              style="width:100%"
              placeholder="Data Per Halaman"
              @change="changePageSize"
              :options="[10, 25, 100, 'Semua Data']"
            />
          </div>
        </div>
        <div class="col-sm-12 col-xl-4">
          <div class="form-group">
            <multiselect
              class="mulit-select"
              label="namaKategori"
              placeholder="Pilih Kategori Anggota"
              :show-labels="false"
              required
              v-model="kategori_anggota"
              :options="optionKategoriAnggota"
            ></multiselect>
            
          </div>
        </div>
        <div class="col-sm-12 col-xl-4">
          <div class="form-group">
            <input 
              placeholder=" Tanggal Daftar" 
              class="form-control" 
              type="text" 
              onfocus="(this.type='date')" 
              id="date"
              style="width:100%"
            >
          </div>
        </div>
        
        <div class="col-sm-12 col-xl-4">
          <div class="form-group">
            <multiselect
              class="mulit-select"
              label="nama_pelatihan"
              placeholder="Pilih Pelatihan"
              :show-labels="false"
              required
              v-model="pelatihan"
              @select="changePelatihan"
              :options="dataPelatihan"
            ></multiselect>
           
          </div>
        </div>
        <div class="col-sm-12 col-xl-4">
          <div class="form-group">
            <CSelect
              class="float-left"
              style="width:100%"
              placeholder="Pilih Status Pembayaran"
              :options="['Lunas', 'Tertunda' , 'Kadaularsa', 'Semua Data']"
            />
          </div>
        </div>
        <div class="col-sm-12 col-xl-4 ml-auto">
          <div class="form-group">
            <CInput
              class="float-right"
              style="width:100%"
              placeholder="Cari Data .."
              v-model="searchPelatihan"
            />
          </div>
        </div>
      </CRow>
     
      <CRow>
        <CCol lg="12" class="table-responsive">
          <CDataTable 
            class="w-100" 
            :items="items" 
            :fields="fields" 
            hover 
            sorter
          >
            <template #no="{item}">
              <td class="py-2">{{ item.no }}</td>
            </template>
            <template #no_anggota="{item}">
              <td class="py-2">{{ item.no_anggota ? item.no_anggota : '-' }}</td>
            </template>
            <template #nama="{item}">
              <td
                class="py-2 text-info"
                style="cursor: pointer"
                @click="detailUser(item, index)"
              >{{ item.nama ? item.nama : '-' }}</td>
            </template>
            <template #status_pembayaran="{item}">
              <td
                class="py-2 font-weight-bold text-success"
                v-if="item.status_pembayaran == 'settlement'"
              >Lunas</td>
              <td
                class="py-2 font-weight-bold text-danger"
                v-else-if="item.status_pembayaran == 'failure'"
              >Pembayaran gagal</td>
              <td
                class="py-2 font-weight-bold text-warning"
                v-else-if="item.status_pembayaran == 'pending'"
              >Menunggu Pembayaran</td>
              <td
                class="py-2 font-weight-bold text-danger"
                v-else-if="item.status_pembayaran == 'expired'"
              >Waktu Transaksi Berakhir</td>
              <td class="py-2 font-weight-bold text-danger" v-else>Belum Lunas</td>
            </template>
            <template #aksi="{item}">
              <td class="py-2 d-flex align-items-center">
                <CButton
                  color="success"
                  class="btn-sm"
                  square
                  @click="Detail(item.id_pelatihan_peserta)"
                >
                  <font-awesome-icon icon="eye" />
                </CButton>&nbsp;&nbsp;
              </td>
            </template>
          </CDataTable>
          <CPagination
            style="float:right"
            :active-page.sync="currentPage"
            :pages="pagination.totalPages"
            responsive
            @click="pageChange"
          />
        </CCol>
      </CRow>
      <!-- Modal Detail User -->
      <CModal
        title="Modal title"
        :show.sync="modalDetail"
        :no-close-on-backdrop="true"
        :centered="true"
      >
        <CRow>
          <div class="modal-body row my-n3">
            <div class="col-5">
              <p class="font-weight-bold">No Anggota</p>
              <p class="font-weight-bold">Nama Anggota</p>
              <p class="font-weight-bold">Email</p>
              <p class="font-weight-bold">No. Handphone</p>
              <p class="font-weight-bold">No. Telepon</p>
            </div>
            <div class="col-7">
              <p>: AGT-1</p>
              <p>: Samantha Wiliam</p>
              <p>: samantha@gmail.com</p>
              <p>: 087837432432</p>
              <p>: 034329423423</p>
            </div>
          </div>
        </CRow>
        <template #header>
          <h6 class="modal-title h5 font-weight-bold">Detail Anggota</h6>
        </template>
        <template #footer>
          <router-link to="/keanggotaan/data-anggota">
            <CButton color="info">Detail</CButton>
          </router-link>
          <CButton @click="modalDetail = false" color="danger">Tutup</CButton>
        </template>
      </CModal>
      <!-- End Modal -->
      <!-- Modal Detail User -->
      <CModal
        title="Modal title"
        :show.sync="modalDetailPeserta"
        :no-close-on-backdrop="true"
        :centered="true"
        size="lg"
      >
        <CRow class="px-3">
          <table class="table table-bordered font-weight-bold">
            <tr>
              <th class="bg-primary" style="width: 40%">No Lapor Pelatihan</th>
              <td>{{ detailPeserta.no_lapor_pelatihan ? detailPeserta.no_lapor_pelatihan : '-' }}</td>
            </tr>            
            <tr>
              <th class="bg-primary" style="width: 40%">Nama Pelatihan</th>
              <td>{{detailPeserta.nama_pelatihan ? detailPeserta.nama_pelatihan : '-'}}</td>
            </tr>
            <tr>
              <th class="bg-primary" style="width: 40%">Tanggal Pendaftaran</th>
              <td>{{detailPeserta.tanggal_daftar ? detailPeserta.tanggal_daftar : '-'}}</td>
            </tr>
            <tr>
              <th class="bg-primary" style="width: 40%">Status Pembayaran</th>
              <td>{{detailPeserta.status_pembayaran ? detailPeserta.status_pembayaran : '-'}}</td>
            </tr>
            <tr>
              <th class="bg-primary" style="width: 40%">Perolehan SKP Terstruktur</th>
              <td>{{detailPeserta.skp ? detailPeserta.skp : '-'}}</td>
            </tr>
            <tr>
              <th class="bg-primary" style="width: 40%">Perolehan SKP Non Terstruktur</th>
              <td>{{detailPeserta.skp ? detailPeserta.skp : '-'}}</td>
            </tr>
            <tr>
              <th class="bg-primary" style="width: 40%">Assesment</th>
              <td>{{detailPeserta.skp ? detailPeserta.skp : '-'}}</td>
            </tr>
            <tr>
              <th class="bg-primary" style="width: 40%">Status Pengisian Kuesioner</th>
              <td class="text-danger font-weight-bold">-</td>
            </tr>
            <tr>
              <th class="bg-primary" style="width: 40%">Status E-Certificate</th>
              <td class="text-success font-weight-bold">-</td>
            </tr>
          </table>
        </CRow>
        <template #header>
          <h6 class="modal-title h4 font-weight-bold">Detail</h6>
        </template>
        <template #footer>
          <CButton @click="modalDetailPeserta = false" color="danger">Tutup</CButton>
        </template>
      </CModal>
      <!-- End Modal -->
    </CCardBody>
    <!-- End Data Peserta -->
</template>

<script>
import DataPesertaService from "../../../services/pelatihan/data-peserta.service";
import { AlertUtils } from "../../../mixins/AlertUtils";
import { Pagination } from "../../../mixins/Pagination";
import { KategoriAnggota } from "../../../mixins/master/KategoriAnggota";
const fields = [
  {
    key: "no",
    label: "No",
    sorter: true,
    filter: false
  },
  {
    key: "no_anggota",
    label: "No Anggota",
    sorter: true,
    filter: false
  },
  {
    key: "nama_lengkap",
    label: "Nama",
    sorter: true,
    filter: false
  },
  {
    key: "tanggal_daftar",
    label: "Tanggal Daftar",
    sorter: true,
    filter: false
  },
  {
    key: "status_pembayaran",
    label: "Status Pembayaran",
    sorter: true,
    filter: false
  },
  {
    key: "aksi",
    _style: "width: 10%; text-align: center",
    sorter: false,
    filter: false
  }
];

export default {
  mixins: [
    AlertUtils, 
    Pagination,
    KategoriAnggota
  ],
  data() {
    return {
      formData: [
        {
          idWorkshopPelatihan: "",
          id_workshop_pelatihan: ""
        }
      ],
      pelatihan:'',
      kategori_anggota : '',
      items: [],
      detailPeserta: {
        id_keanggotaan: "",
        id_user: "",
        id_pelatihan_peserta: "",
        nama_pelatihan: "",
        id_workshop_pelatihan: "",
        no_anggota: "",
        nama_lengkap: "",
        tanggal_daftar: "",
        status_pembayaran: "",
        id_invoice: "",
        created_at: "",
        pelatihan_created_at: "",
        no_lapor_pelatihan: "",
        skp: ""
      },
      dataPelatihan: [],
      fields,
      details: [],
      status: false,
      myModal: false,
      modalDetail: false,
      modalDetailPeserta: false,
      horizontal: { label: "col-3", input: "col-9" },
      collapseDuration: 0,
      content: []
    };
  },

  mounted() {
    this.getData(
      "0",
      this.pageSize,
      this.idWorkshopPelatihan,
      this.searchPelatihan
    );
    this.getAllKategoriAnggota();
    this.getPelatihan();
    this.getDetailPeserta();
  },

  methods: {
    pageChange() {
      this.getData(currenPage);
    },

    Detail(id_pelatihan_peserta) {
      this.modalDetailPeserta = true;
      this.getDetailPeserta(id_pelatihan_peserta);
    },

    getData(currentPage, pageSize, idWorkshopPelatihan, filter) {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });

      var vm = this;

      DataPesertaService.getDataPeserta(
        currentPage,
        pageSize,
        idWorkshopPelatihan,
        filter
      )
        .then(response => {
          loader.hide();

          // comment console console.log(response.data.data.content);

          vm.items = response.data.data.content;
          vm.pagination.totalPages = response.data.data.totalPages;
          vm.currentPage = response.data.data.pageable.pageNumber + 1;
        })
        .catch(error => {
          // comment console console.log(error);
        });
    },

    getDetailPeserta(idPelatihanPeserta) {
      var vm = this;

      DataPesertaService.detailDataPeserta(idPelatihanPeserta)
      .then(response => {
          
          // comment console console.log(response.data.singleData);
          vm.detailPeserta.no_lapor_pelatihan = "";
          vm.detailPeserta.id_keanggotaan =
            response.data.singleData.id_keanggotaan;
          vm.detailPeserta.id_user = "";
          vm.detailPeserta.id_pelatihan_peserta = "";
          vm.detailPeserta.nama_pelatihan = "";
          vm.detailPeserta.id_workshop_pelatihan = "";
          vm.detailPeserta.no_anggota = "";
          vm.detailPeserta.nama_lengkap = response.data.singleData.nama_lengkap;
          vm.detailPeserta.tanggal_daftar = "";
          vm.detailPeserta.status_pembayaran = "";
          vm.detailPeserta.id_invoice = "";
          vm.detailPeserta.created_at = "";
          vm.detailPeserta.pelatihan_created_at = "";
          vm.detailPeserta.no_lapor_pelatihan = "";
          vm.detailPeserta.skp = "";
        })
        .catch(error => {
          // comment console console.log(error);
        });
    },

    getPelatihan() {
      var vm = this;
      DataPesertaService.getPelatihan()
      .then(response => {
        vm.dataPelatihan = response.data.data.content;
        // comment console console.log(response.data.data.content);
      })
      .catch(error => {
        // comment console console.log(error);
      });
    },

    changePelatihan(value) {
      this.getData("0", this.pageSize, value.id_workshop_pelatihan, this.searchPelatihan);
      this.modelIdWorkshopPelatihan = value.id_workshop_pelatihan;
      // this.getData(e);
    }
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
